module.exports = "/work-site/img/maptile.ff71ea5c.png";